module.exports = __webpack_public_path__ + "static/media/cloud-bg-1.d851da31.png";